import { useMemo, useState } from "react";
import { createCalculationRowsSelector } from "@/lib/calculation-rows";
import type { Transaction } from "@/lib/finance";
/** Aggregate inputs only: never use for owner-facing row details or saves. */
export function useCalculationRows(rows: Transaction[]) {
  const [select] = useState(() => createCalculationRowsSelector());
  return useMemo(() => select(rows), [select, rows]);
}
